import { render, staticRenderFns } from "./AdminDashAbsencesPanel.vue?vue&type=template&id=c1461cae&scoped=true"
import script from "./AdminDashAbsencesPanel.vue?vue&type=script&lang=js"
export * from "./AdminDashAbsencesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1461cae",
  null
  
)

export default component.exports